export const ADMIN_EMAILS = ['cathystead@gmail.com', 'hlogue@gmail.com'];

export const defaultTestimonials = [
  { id: '1', name: 'Sarah M.', role: 'Parent', text: "Catherine has transformed my daughter's confidence in singing. The lessons are structured, fun, and my daughter looks forward to every session. We couldn't be happier!", rating: 5, enabled: true },
  { id: '2', name: 'Tom R.', role: 'Adult Student', text: "I started singing lessons as a complete beginner and within months I was performing at a local open mic. Catherine's teaching style is encouraging and professional.", rating: 5, enabled: true },
  { id: '3', name: 'Emma K.', role: 'Parent', text: "My son loves his singing lessons. Catherine makes every child feel special and capable. His school teachers have noticed the difference in his confidence too.", rating: 5, enabled: true },
  { id: '4', name: 'David L.', role: 'Adult Student', text: "As someone who always wanted to sing but never had the courage, finding Singvolve was life-changing. Patient, skilled, and genuinely passionate about helping you find your voice.", rating: 5, enabled: true },
];

export const defaultFAQs = [
  { id: '1', question: 'What age can children start singing lessons?', answer: 'Children can start from age 7. Younger children may be considered on a case-by-case basis depending on their attention span and enthusiasm for singing.', order: 1 },
  { id: '2', question: 'Do I need any prior musical experience?', answer: 'Not at all! We welcome complete beginners of all ages. Whether you have never sung before or have some experience, lessons are tailored to your level.', order: 2 },
  { id: '3', question: 'Where do lessons take place?', answer: 'Lessons are held at Bristol Cathedral Choir School (BCCS) in central Bristol. The school offers a wonderful musical environment for learning.', order: 3 },
  { id: '4', question: 'How long is each lesson?', answer: 'Each lesson is 30 minutes long, which is the ideal duration for focused vocal development without fatigue.', order: 4 },
  { id: '5', question: 'How do I book lessons?', answer: 'Simply contact us via email to book your first lesson or enquire about our free taster sessions. We will get back to you within 24 hours.', order: 5 },
  { id: '6', question: 'What styles of music do you teach?', answer: 'We cover a range of styles including pop, musical theatre, classical, folk, and more. Lessons are tailored to the styles you enjoy most.', order: 6 },
  { id: '7', question: 'Can adults take lessons too?', answer: 'Absolutely! We teach students of all ages. Many of our adult students started as complete beginners and have made wonderful progress.', order: 7 },
  { id: '8', question: 'What happens in a typical lesson?', answer: 'Each lesson includes warm-up exercises, breathing techniques, vocal exercises for range and control, and working on songs of your choice. The approach is always encouraging and supportive.', order: 8 },
];

export const defaultResources = [
  {
    id: '1',
    type: 'video',
    title: 'Breathing Exercises for Singers',
    description: 'Learn fundamental breathing techniques that will support your singing practice at home.',
    url: 'https://www.youtube.com/embed/dQw4w9WgXcQ',
    order: 1,
  },
  {
    id: '2',
    type: 'article',
    title: 'How to Warm Up Your Voice',
    description: 'A step-by-step guide to warming up your voice before singing. Essential reading for all students.',
    url: '',
    order: 2,
  },
  {
    id: '3',
    type: 'article',
    title: 'Managing Performance Nerves',
    description: 'Tips and techniques for managing anxiety before and during performances.',
    url: '',
    order: 3,
  },
];

export const defaultPricingServices = [
  {
    id: '1',
    name: 'Lesson Block',
    description: 'Our standard lesson package',
    price: '25',
    priceLabel: 'per lesson',
    lessonCount: '6',
    lessonDuration: '30',
    features: [
      'One-to-one tuition',
      'Tailored to your goals',
      'All ages and abilities',
      'Access to Student Portal',
      'Lesson notes after each session',
      'Homework and practice tips',
    ],
    ctaText: 'Book Now',
    ctaType: 'book',
    highlighted: true,
    enabled: true,
    order: 1,
  },
];

export const defaultSiteSettings = {
  tasterEnabled: true,
  tasterDate: 'Saturday, 15th March 2026',
  tasterTime: '10:00 AM',
  tasterLocation: 'Bristol Cathedral Choir School',
  bookLessonsEnabled: true,
  waitlistMode: false,
  adminEmail: 'catherine@singvolve.com',
  lessonPrice: '25',
  lessonCount: '6',
  lessonDuration: '30',
  socialLinks: {
    facebook: '',
    instagram: '',
    youtube: '',
  },
  images: {
    hero: '',
    about: '',
    location: 'https://images.pexels.com/photos/35422693/pexels-photo-35422693.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
  },
};
